/**
 * ContinuePrompt — the arcade "CONTINUE?" countdown under the result panel
 * when the lives run out. INSERT COIN (or ENTER) continues on the same stage
 * with the same energy; GAME OVER, ESC or the countdown reaching 0 ends it.
 */

import SoundManager from "../SoundManager";
import { FONT_SIZE, fontStyle } from "../FontScale";
import { fitText, stack } from "../view/layout";

const COUNTDOWN_S = 10;
const DEPTH = 410;

/**
 * @param {Phaser.Scene} scene - draws from scene.overlayNextY
 * @param {{ subtitle: string, onContinue: () => void, onGiveUp: () => void }} p
 */
export function showContinuePrompt(scene, { subtitle, onContinue, onGiveUp }) {
  const CX = scene._CX;
  const parts = [];
  const add = (content, size, color) => {
    const t = scene.add
      .text(CX, 0, content, fontStyle(size, color, { stroke: "#000000", strokeThickness: 3 }))
      .setOrigin(0.5, 0)
      .setDepth(DEPTH);
    parts.push(fitText(t, scene._W - 24));
    return t;
  };
  const title = add("CONTINUE?", FONT_SIZE.TITLE, "#FFD84A");
  const count = add(String(COUNTDOWN_S), FONT_SIZE.TITLE, "#FF3333");
  const note = add(subtitle, FONT_SIZE.CAPTION, "#FFFFFF");
  const yes = add("INSERT COIN", FONT_SIZE.HEADING, "#7BC74A").setInteractive({ useHandCursor: true });
  const no = add("GAME OVER", FONT_SIZE.BODY, "#AAAAAA").setInteractive({ useHandCursor: true });
  const top = scene.overlayNextY ?? scene._H * 0.55;
  const bottom = stack([title, count, note, yes, no], top + 10, 8);
  const panelW = Math.min(460, scene._W - 24);
  const panel = scene.add.graphics().setDepth(DEPTH - 1);
  panel.fillStyle(0x000000, 0.88);
  panel.fillRoundedRect(CX - panelW / 2, top, panelW, bottom - top + 10, 10);
  panel.lineStyle(2, 0xffd84a, 0.8);
  panel.strokeRoundedRect(CX - panelW / 2, top, panelW, bottom - top + 10, 10);
  parts.push(panel);

  let left = COUNTDOWN_S;
  let settled = false;
  const settle = (next) => {
    if (settled) return;
    settled = true;
    timer.remove();
    scene.input.keyboard.off("keydown-ENTER", onEnter);
    scene.input.keyboard.off("keydown-ESC", onEsc);
    parts.forEach((p) => p.destroy());
    next();
  };
  const onEnter = () => settle(onContinue);
  const onEsc = () => settle(onGiveUp);
  const timer = scene.time.addEvent({
    delay: 1000,
    repeat: COUNTDOWN_S - 1,
    callback: () => {
      left -= 1;
      count.setText(String(left));
      SoundManager.playHazardWarning();
      if (left === 0) settle(onGiveUp);
    },
  });
  yes.on("pointerdown", onEnter);
  no.on("pointerdown", onEsc);
  scene.input.keyboard.on("keydown-ENTER", onEnter);
  scene.input.keyboard.on("keydown-ESC", onEsc);
}
